import i18n from "../../../../../i18n";

export const salesPermitProps: Record<
  string,
  { label: string; color: "warning" | "error" }
> = {
  YELLOW: {
    label: i18n.t("common:salesRestriction"),
    color: "warning",
  },
  RED: {
    label: i18n.t("order:noSales"),
    color: "error",
  },
  UNKNOWN: {
    label: i18n.t("order:riskUnknown"),
    color: "warning",
  },
};
